import * as types from "../actions/ActionTypes"
import initialState from "./initialState";
import {padString} from "../../utils";
import {INSERT_CONTRACT, PUT_CONTRACT, PUT_OR_INSERT, SET_CONTRACTS} from "../actions/contractsActions";


export default (state = initialState.contracts, action) => {
    switch (action.type) {
        case SET_CONTRACTS : {
            let {data} = action.payload;
            return data;
        }
        case PUT_CONTRACT: {
            let contractForUpdate = action.payload && action.payload.data;
            if (!contractForUpdate) return state;

            return state.map(item =>
                (item.id === contractForUpdate.id)
                    ? {...item, ...contractForUpdate}
                    : {...item})
        }
        case INSERT_CONTRACT:
            return [...state, ...action.payload.data];
        case PUT_OR_INSERT : {
            // TODO delegate action to middleware
            let contract = action.payload && action.payload.data;
            // filter through the contracts in state and replace contract if it was found.
            contract = {...contract, contractNumber: padString(contract.contractNumber, "C", 6)};

            let contractToReplace = state.find(c => c.id === contract.id);
            let updatedState = [];

            if (contractToReplace) {
                // contract already exist in state update and replace it.
                contractToReplace = {
                    ...contractToReplace,
                    ...contract
                };
                updatedState = state.map(c => (c.id === contractToReplace.id) ? contractToReplace : c)
            } else {
                // just add contract to state.
                updatedState = [...state, contract]
            }
            return updatedState;
        }
        default:
            return state;
    }
}
